import { Donuz } from "donuz-js/Donuz";
import Loading from "@/components/Loading.vue";

// @ is an alias to /src
export default {
    name: "contct",
    components: {
        Loading
    },
    data() {
        return {
            obj: {},
            value: "",
            code: "",
            configs: [],
            loading: true
        };
    },
    async created() {
        this.obj = await this.getAdmins();
        this.obj = this.obj.estabelecimentos[0];
        let result = await Donuz.scoringCode.getFields();
        if (result.status == 200) {
            this.configs = result.campos;
        }
        this.loading = false
    },
    methods: {
        submit: async function() {
            let result = await Donuz.scoringCode.insertCode(
                sessionStorage.getItem(btoa("tokenCliente")), {
                    codigo: this.code,
                    valor: this.value
                }
            );
            if (result.status == 200) {
                M.toast({ html: result.mensagem, classes: "green" });
            } else {
                M.toast({ html: result.mensagem, classes: "red" });
            }
        }
    }
};